/* Tabbed FAQ: one topic shows at a time; #anchor in the URL opens that topic. */
(() => {
  if (customElements.get('faq-tabs')) return;

  class FaqTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
      const bar = this.querySelector('[data-faq-bar]');
      if (!this.tabs.length || !bar) return;

      bar.hidden = false;
      this.classList.add('faq-tabs--ready');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tab.dataset.faqTab, { updateHash: true }));
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
          if (e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
          if (e.key === 'Home') next = this.tabs[0];
          if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
          if (next) {
            e.preventDefault();
            this.select(next.dataset.faqTab, { updateHash: true });
            next.focus();
          }
        });
      });

      const fromHash = this.fromHash();
      this.select(fromHash || this.tabs[0].dataset.faqTab, { scroll: !!fromHash });

      this.onHash = () => {
        const id = this.fromHash();
        if (id) this.select(id, { scroll: true });
      };
      window.addEventListener('hashchange', this.onHash);

      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const tab = e.target.closest('[data-faq-tab]');
        if (tab) { this.select(tab.dataset.faqTab); return; }
        const panel = e.target.closest('[data-faq-panel]');
        if (panel) this.select(panel.dataset.faqPanel);
        if (e.target.tagName === 'DETAILS') e.target.open = true;
      });
    }

    disconnectedCallback() {
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    }

    fromHash() {
      const id = decodeURIComponent(window.location.hash.replace('#', ''));
      if (!id) return null;
      return this.tabs.some((t) => t.dataset.faqTab === id) ? id : null;
    }

    select(id, opts = {}) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.faqTab === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && tab.scrollIntoView) {
          const list = tab.parentElement;
          const left = tab.offsetLeft - (list.clientWidth - tab.clientWidth) / 2;
          list.scrollTo({ left, behavior: 'smooth' });
        }
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.faqPanel !== id && panel.dataset.faqPanel !== 'all';
      });
      if (opts.updateHash) history.replaceState(null, '', `#${id}`);
      if (opts.scroll) {
        requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
      }
    }
  }

  customElements.define('faq-tabs', FaqTabs);
})();
